<template>
  <v-menu
    v-if="filtersSorted.length"
    transition="scroll-y-transition"
    content-class="top-sheet"
    :close-on-content-click="false"
    dark
    v-model="isMenuShown"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        fab
        :color="activeFilters.length ? 'primary' : 'white'"
        v-bind="attrs"
        v-on="on"
      >
        <filter-icon/>
      </v-btn>
    </template>
    <v-sheet class="text-center" color="transparent">
      <unit-list-filter plain @filtering="$emit('filtering')"/>
    </v-sheet>
  </v-menu>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import UnitListFilter from './UnitListFilter.vue';
import FilterIcon from './icons/Filter.vue';

export default {
  name: 'FilterMenuButton',
  components: { UnitListFilter, FilterIcon },
  props: {
    dockSelector: {
      type: String,
      required: false,
    },
    exterior: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isMenuShown: false,
    }
  },
  computed: {
    ...mapGetters('filters', ['activeFilters', 'filtersSorted']),
  },
  watch: {
    exterior() {
      this.resetPos();
    },
    isMenuShown(newVal) {
      if (newVal) {
        this.stopSunstudyMode();
        this.setActivationButtonSunstudy(false);
      } else {
        this.setActivationButtonSunstudy(true);
      }
    }
  },
  mounted() {
    this.resetPos();
  },
  destroyed() {
    this.resetPos();
  },
  methods: {
    ...mapActions('sunstudy', ['stopSunstudyMode', 'setActivationButtonSunstudy']),
    resetPos() {
      if (this.dockSelector) {
        const dock = document.querySelector(this.dockSelector);

        if (dock) {
          const { x, width } = dock.getBoundingClientRect();

          this.$root.$el.style.setProperty('--filter-menu-dock-x', `${x}px`);
          this.$root.$el.style.setProperty('--filter-menu-dock-width', `${width}px`);
        } else {
          this.$root.$el.style.removeProperty('--filter-menu-dock-x');
          this.$root.$el.style.removeProperty('--filter-menu-dock-width');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/stylesheets/app";
@import "FilterMenuButton";

.top-sheet {
  top: var(--app-main-top) !important;
  left: 50% !important;
  transform: translateX(-50%);
  background-color: rgba(0,0,0,.55) !important;
  border-radius: 5px !important;
  border: none !important;
  filter: drop-shadow(2px 4px 5px #444);

  .filters-panel {
    border-bottom: 0 !important;
  }
}
</style>
